module.exports = __webpack_public_path__ + "static/media/21ECLAC14.4d9d70bd.jpg";